import React from 'react'
import InfoFieldGroup from '../../../utils/InfoField/InfoFieldGroup'
import Header from './header'
import ButtonSwitch from './buttonSwitch'

export default function GenericosPrivilegios({user, permissions, setPermissions}) {
  return (
    <>
      <Header header={''} />

      <InfoFieldGroup
        fields={
          [
            {
              // label: 'Dashboard',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'Dashboard'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Dashboard'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'Relatório'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Relatório'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'AutorizaçãoEmitidas'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Autorização Emitidas'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'editAutorizacao'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Editar Autorização'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'Chat'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Chat'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'reclamacoes'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Reclamações'}
                  descricao={''}
                />
              , editable: false,
            },

          ]}

      />

    </>
  )
}
